import axios from "axios";
import { API_ENDPOINT } from "../../common/constants/apiConstants";

export const getAllReports = async (params = {}) => {
  const url = `${API_ENDPOINT.REPORT_EVALUATION.GET_ALL_REPORTS}`;
  try {
    const response = await axios.get(url, { params });
    return response.data;
  } catch (error) {
    console.error("Get All Reports API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const fetchAllSurveyFeedback = async () => {
  const url = `${API_ENDPOINT.STUDENT_SURVEY.FETCH_ALL}`;
  try {
    const response = await axios.post(url, {});
    return response.data;
  } catch (error) {
    console.error("Fetch Survey Feedback API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getAdminSurveyFeedback = async (interviewId) => {
  const url = `${API_ENDPOINT.ADMIN_SURVEY.GET_BY_INTERVIEW}/${interviewId}`;
  try {
    const response = await axios.get(url);
    const data = response.data;
    // API returns 200 with no body when no survey exists
    if (data == null || data === "") return null;
    if (typeof data === "object" && !Array.isArray(data) && Object.keys(data).length === 0) return null;
    return data;
  } catch (error) {
    console.error("Get Admin Survey Feedback API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const createAdminSurvey = async (payload) => {
  const url = `${API_ENDPOINT.ADMIN_SURVEY.CREATE}/`;
  try {
    const response = await axios.post(url, payload, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error("Create Admin Survey API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
};
